import { headers} from "../../common/credentials";

const port = "8000";
const port1="8002";
const baseUrl = "http://172.16.40.14:";

export const getFileUploadListFromServer = () => {
    let url = baseUrl + port1 + "/api/v2/alcs/generic/file_uploads/";
    return ([headers, url]);
}

export const getFileList = () => {
    let url = baseUrl + port1 + "/api/v2/alcs/file_type_list/";
    return ([headers, url]);
}